import { Component, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PacchettoItem } from 'src/app/_classi/PacchettoItem';
import { VinoItem } from 'src/app/_classi/VinoItem';
import { CarrelloViniService } from 'src/app/_servizi/carrelloVini.service';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';
import { PromoService } from 'src/app/_servizi/promo.service';

@Component({
  selector: 'app-acquisto-pacchetto',
  templateUrl: './acquisto-pacchetto.component.html',
  styleUrls: ['./acquisto-pacchetto.component.css']
})
export class AcquistoPacchettoComponent {

  @Input() pacchetto: PacchettoItem;

  tvAssociata = null;
  tvSelezionata = null;

  qtaMinima = 1;

  promoSelezionata = null;
  codicePromo = null;

  risultato = null;

  idCookie = null;

  constructor(
    private messageService: MessageServiceService,
    private fb: FormBuilder,
    private promoService: PromoService,
    public dialog: MatDialog,
    private carrelloService: CarrelloViniService,
    private router: Router,
    private translate: TranslateService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.tvAssociata = this.pacchetto.associata_item;

    this.pacchetto.qta = 1;
    this.qtaMinima = 1;
    this.pacchetto.qta = this.qtaMinima;
  }


  ngOnInit(): void {
  }

  getCostoTipovisita(tipovisita): number {
    const przVisita = parseFloat(tipovisita.costoDefault);
    let przOk = 0;
    if (przVisita > 0) {
      przOk = przVisita;
    } else {
      przOk = parseFloat(tipovisita.costoDefault);
    }
    return przOk;
  }

  getCostoTipovisitaScontato(tipovisita, valore): number {
    const przVisita = parseFloat(tipovisita.costoMax);
    let przOk = 0;
    if (przVisita > 0) {
      przOk = przVisita;
    } else {
      przOk = parseFloat(tipovisita.costoDefault);
    }
    przOk = przOk - (przOk / 100 * valore);
    return przOk;
  }

  public choosePrezzoScontato(pacchetto): number {
    return pacchetto.costo;
  }

  get totalePacchetti(): number {
    let costo = 0;
    costo = this.pacchetto.getCosto() * this.pacchetto.qta;
    return costo;
  }

  get totalePacchettiConPromo(): number {
    let costo = 0;
    let promo = this.promoSelezionata;

    costo = this.pacchetto.choosePrezzoScontato() * this.pacchetto.qta;
    if (promo.promo.tipo === '0') {
      costo = costo - parseFloat(promo.promo.valore);
    } else {
      costo = costo - (costo / 100 * parseFloat(promo.promo.valore));
    }

    if (this.pacchetto.opzioni && this.pacchetto.opzioni.length > 0) {
      for (const opzione of this.pacchetto.opzioni) {
        if (opzione.selezionata) {
          costo += parseFloat(opzione.costo);
        }
      }
    }

    return costo;
  }

  get totalePacchettoSingolo(): number {
    let costo = 0;
    costo = this.pacchetto.choosePrezzoScontato();
    return costo;
  }

  get totaleBasePacchetti(): number {
    let costo = 0;
    costo = this.pacchetto.getCosto();
    return costo;
  }

  get totaleTv(): number {
    return this.tvSelezionata ? this.getCostoTipovisitaScontato(this.tvSelezionata, this.tvSelezionata.scontoAssociata) : 0;
  }

  get totaleGenerale(): number {
    return (this.promoSelezionata ? this.totalePacchettiConPromo : this.totalePacchetti) + this.totaleTv;
  }

  get totalescontato(): number {
    let totaleScontato = 0;
    if (this.promoSelezionata && this.promoSelezionata.promo) {
      const przVino = this.totalePacchettoSingolo;
      const totaleVini = przVino * this.pacchetto.qta;

      this.promoSelezionata = this.promoService.controllaPromo(
        this.promoSelezionata.promo, this.pacchetto.qta, totaleVini, przVino, this.promoSelezionata.codice
      );

      if (this.promoSelezionata.risultato) {
        const totScontato = this.totalePacchetti - this.promoSelezionata.valore;
        totaleScontato = totScontato >= 0 ? totScontato : 0;
      } else {
        totaleScontato = this.totalePacchetti;
      }
    } else {
      totaleScontato = this.totalePacchetti;
    }
    return totaleScontato + this.totaleTv;
  }

  settaAssociata(tipovisita) {
    this.tvSelezionata = tipovisita;
  }

  resettaAssociata() {
    this.tvSelezionata = null;
  }

  pacchettoPiu() {
    this.pacchetto.qta += 1;
  }

  pacchettoMeno() {
    if (this.pacchetto.qta > 1 && this.pacchetto.qta > this.qtaMinima) {
      this.pacchetto.qta--;
    }
  }

  addOpzione(opzione) {
  }

  isDisabled() {
    return this.codicePromo == null ||
      this.codicePromo === '' ||
      (this.promoSelezionata && this.promoSelezionata.risultato)
      ? true : false;
  }

  riscattaCodice() {

    const initialState = {
      titolo: 'Riscatta il tuo codice',
      label: 'Inserisci il tuo codice regalo',
      idVino: this.pacchetto.id,
      codiceForm: this.pacchetto.codiceForm,
      qta: this.pacchetto.qta,
      costoTotale: this.totaleBasePacchetti,
      costoSingolo: this.totaleBasePacchetti / this.pacchetto.qta,
      false: true
    };

    this.riscatta(initialState)
  }

  riscatta(data) {
    this.risultato = null;
    this.promoService.riscattaCodicePromoVino(data.idVino, data.codiceForm, this.codicePromo, data.isVino)
      .subscribe(response => {
        if (response.length > 0) {
          this.controllaPromoVino(response[0]);
        } else {
          this.risultato = {
            risultato: false,
            codice: '',
            valore: 0,
            label: '',
            errore: 'promodialogo.nonvalido',
            data1: '',
            data2: '',
            promo: null,
          };
        }
      });
  }

  controllaPromoVino(promodacontrollare) {
    this.risultato = this.promoService.controllaPromoVino(
      promodacontrollare,
      this.pacchetto.qta,
      this.totalePacchettoSingolo * this.pacchetto.qta,
      this.totalePacchettoSingolo / this.pacchetto.qta,
      this.codicePromo
    );
    this.promoSelezionata = this.risultato;
  }

  primoStepPagamento() {

    if (this.tvAssociata && this.tvSelezionata) {
      this.procediAcquistoConVisita(this.pacchetto);
    } else {
      this.procediAcquistoPacchetto(this.pacchetto);
    }
  }


  procediAcquistoConVisita(pacchetto) {

    let visitaS = this.tvAssociata;

    let arrayFittizio = [];
    pacchetto.totaleFinale = pacchetto.totaleFinale = this.totalescontato - this.totaleTv;
    pacchetto.promo = this.promoSelezionata && this.promoSelezionata.promo ? this.promoSelezionata.promo.codice : '';
    arrayFittizio.push(pacchetto)


    const valori = {
      idClientiMaster: pacchetto.idCantina,
      idCliente: null,
      idCantina: pacchetto.idCantina,
      idTipoVisita: visitaS.id,
      durata: visitaS.duratagg,
      tiporegala: visitaS.tiporegala,
      fineregala: visitaS.fineregala,
      npersone: 1,
      totale: this.totaleTv,
      pacchetti: this.getIdsQtaPacchettiSelezionatiBox(arrayFittizio)
    };

    this.addCarrelloBuonoCantina(valori);
  }

  procediAcquistoPacchetto(pacchetto) {

    let arrayFittizio: any = [];
    pacchetto.totaleFinale = this.totalescontato;
    pacchetto.promo = this.promoSelezionata && this.promoSelezionata.promo ? this.promoSelezionata.promo.codice : '';
    arrayFittizio.push(pacchetto)

    const valori = {
      idCliente: null,
      idCantina: pacchetto.idCantina,
      pacchetti: this.getIdsQtaPacchettiSelezionatiBox(arrayFittizio),
    };

    this.addCarrelloPacchetto(valori);
  }

  getIdsQtaPacchettiSelezionatiBox(pacchetti: any[]): string {
    const selezionati = [];
    if (pacchetti && pacchetti.length > 0) {
      pacchetti.forEach(pacchetto => {
        const opzioniSelezionate = [];
        if (pacchetto.opzioni && pacchetto.opzioni.length > 0) {
          for (const opzione of pacchetto.opzioni) {
            if (opzione.selezionata) {
              opzioniSelezionate.push(opzione.id);
            }
          }
        }
        if (opzioniSelezionate.length > 0) {
          selezionati.push(pacchetto.id + ',' + pacchetto.qta + ',' + pacchetto.totaleFinale + ',' + pacchetto.promo + ',' + opzioniSelezionate.join(':'));
        } else {
          selezionati.push(pacchetto.id + ',' + pacchetto.qta + ',' + pacchetto.totaleFinale + ',' + pacchetto.promo + ',' + '0');
        }
      });
      return selezionati.join(';');
    } else {
      return null;
    }
  }

  addCarrelloBuonoCantina(valori) {
    this.carrelloService.addCarrello('carrelloBuonoCantina', valori)
      .subscribe(result => {
        this.gestisciRisultatoInserimentoCarrello(result);
      });
  }

  addCarrelloPacchetto(valori) {
    this.carrelloService.addCarrello('carrelloPacchetto', valori)
      .subscribe(result => {
        this.gestisciRisultatoInserimentoCarrello(result);
      });
  }

  gestisciRisultatoInserimentoCarrello(result) {
    if (result['risultato'] === true) {
      this.messageService.sendClickMessage(null, null, this.translate.currentLang, 2, this.messageService.getIdCookie());
    }
  }
}

